export class SetGroupRoleSuccess {
  public static readonly type = '[Authorisation] SetGroupRoleSuccess';
  constructor(
    public readonly result: any,
    public readonly groupId: string,
  ) {}
}
